<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/trainers',
          title: 'Trainers'
        }
      ]"
      :value="trainersPage.hero_section"
    >
      <template v-if="trainersPage.hero_section.cta" #cta>
        <HeroCta :value="trainersPage.hero_section.cta" />
      </template>
    </HeroSection>

    <TrainerPersonsSection
      :filters-value="filtersValue"
      :value="trainersPage.trainers_section"
      :what-menu="whatMenu"
      class="mb-16 hero-section hero-below-offset"
      main
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="trainersPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'

const props = defineProps({
  trainers: {
    required: true,
    type: Array
  },
  trainersPage: {
    required: true,
    type: Object
  },
  whatMenu: {
    required: true,
    type: Object
  }
})

useProvideTrainerPersonsStore(props.trainers)

const filtersValue = ref()

onBeforeMount(async () => {
  const url = new URL(window.location.href)
  const what = url.searchParams.get('what')

  filtersValue.value = {
    ...(what ? { what } : undefined)
  }
})
</script>
